/**
 * Servers this device is leaving or deleting on purpose (Leave Server,
 * Delete Server). The gateway then sends our own GUILD_MEMBER_REMOVE, before
 * or after the request answers; it is no "You were removed from …" (the
 * leave has its own "You left …" toast). A mark lasts a minute: long enough
 * for the frame, short enough that a later kick still says so.
 */
import type { Snowflake } from '@neosocial/protocol';

const MARK_MS = 60_000;
const exits = new Map<Snowflake, number>();

export function markSelfExit(guildId: Snowflake, now = Date.now()): void {
  exits.set(guildId, now + MARK_MS);
}

/** The request was refused: a removal now is someone else's doing again. */
export function clearSelfExit(guildId: Snowflake): void {
  exits.delete(guildId);
}

export function isSelfExit(guildId: Snowflake, now = Date.now()): boolean {
  const until = exits.get(guildId);
  if (until === undefined) return false;
  if (until > now) return true;
  exits.delete(guildId);
  return false;
}
